<template>
  <div class="news-screen-wrap">
    <div class="screen-box">
      <div class="screen-con">
        <div
          v-for="(item,index) in cateList"
          :key="index"
          class="screen-list"
          :class="item.id===selectCate?'active':''"
          @click="sortChange(index, item)"
        >{{item.name}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getArticleSubCates } from "@/api/index";

export default {
  name: "newsSort",
  props: {
    selectCate: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      selectSort: 0,
      sortVal: "",
      cateList: [{ id: 0, name: this.$t('moduleTitles.allInfo') }],
    };
  },
  created() {
    this.getArticleSubCates();
  },
  methods: {
    getArticleSubCates() {
      getArticleSubCates({ pid: 0 }).then((res) => {
        this.cateList = [...this.cateList, ...res.data];
      });
    },
    sortChange(index, item) {
      this.selectSort = index;
      this.$router.push({ path: `/news/${item.id}` });
    },
  },
};
</script>

<style lang="less" scoped>
.news-screen-wrap {
  border-bottom: 1px solid #e1e1e1;
  overflow: hidden;
  height: 53px;
  .screen-box {
    max-width: 1360px;
    padding: 0 10px;
    margin: 0 auto;
    box-sizing: border-box;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    height: 56px;
    .screen-con {
      display: inline-block;
      white-space: nowrap;
      font-size: 0;
      height: 52px;
      min-width: 100%;
      border-bottom: 0;
      .screen-list {
        font-size: 14px;
        display: inline-block;
        height: 52px;
        line-height: 52px;
        padding: 0 20px;
        cursor: pointer;
        &.active {
          border-bottom: 2px solid #333;
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .news-screen-wrap {
    height: 48px;
    .screen-box {
      height: 50px;
      .screen-con {
        height: 47px;
        .screen-list {
          font-size: 12px;
          height: 47px;
          line-height: 47px;
          padding: 0 15px;
        }
      }
    }
  }
}
</style>